import "./style.scss";

import { AccentFlow } from "features/campaigns/ui/Row/Status";

export const buildStatus = ({
  id,
  pauseReasonStatus,
  status,
  campaignIdWithTip,
  onClick,
}) => <AccentFlow id={id} state={status} pause_reason={pauseReasonStatus} />;
